(() => {
  'use strict';
  const root = document.getElementById('ms-offer');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = '1';
  const ids = new Set(JSON.parse(document.getElementById('ms-eligible').textContent).map(String));
  const claimKey = 'menista-shirt-claimed-v1';
  const seenKey = 'menista-shirt-popup-seen-v1';
  const read = key => { try { return localStorage.getItem(key); } catch { return null; } };
  const write = (key, value) => { try { localStorage.setItem(key, value); } catch {} };
  let claimed = read(claimKey) === '1' || root.dataset.claimed === 'true';
  const forms = [...root.querySelectorAll('.ms-form')];
  const submitted = forms.find(form => form.querySelector('[data-ms-claimed]'));
  if (submitted) {
    claimed = true;
    write(claimKey, '1');
    write(seenKey, '1');
  }
  const inline = document.getElementById('ms-product');
  const info = document.querySelector('#MainContent [id$="__product-information"]');
  if (inline && info) info.insertAdjacentElement('afterend', inline);
  const popup = document.getElementById('ms-popup');
  if (popup) {
    popup.querySelectorAll('[data-ms-close]').forEach(button => button.addEventListener('click', () => popup.close()));
    popup.addEventListener('click', event => {
      if (event.target !== popup) return;
      const rect = popup.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) popup.close();
    });
  }
  function renderForms() {
    forms.forEach(form => {
      const fields = form.querySelector('[data-ms-fields]');
      const confirmation = form.querySelector('[data-ms-confirmation]');
      if (fields) { fields.hidden = claimed; fields.disabled = claimed; }
      if (confirmation) confirmation.hidden = !claimed;
    });
  }
  renderForms();
  forms.forEach(form => {
    form.querySelector('[data-ms-reset]')?.addEventListener('click', () => {
      claimed = false;
      write(claimKey, '0');
      renderForms();
      form.querySelector('input[type="email"]')?.focus();
    });
    // Keep Shopify's native submission, validation and spam protection.
    form.addEventListener('submit', () => {
      form.querySelector('[data-ms-progress]').hidden = false;
      const button = form.querySelector('button[type="submit"]');
      button.textContent = 'Saving your signup…';
      button.setAttribute('aria-busy', 'true');
    });
  });
  const hashId = location.hash.slice(1);
  const returnedForm = forms.find(form => form.id === hashId);
  if (submitted || forms.some(form => form.querySelector('[role="alert"]'))) {
    const target = returnedForm || forms.find(form => !popup?.contains(form)) || forms[0];
    if (target) {
      if (popup?.contains(target)) popup.showModal();
      requestAnimationFrame(() => {
        target.scrollIntoView({ block: 'center' });
        (target.querySelector('[data-ms-confirmation]:not([hidden]),[role="alert"]') || target).focus({ preventScroll: true });
      });
    }
  }
  const propertyName = 'Free shirt signup';
  const propertyValue = 'Claimed — one complimentary tailored dress shirt with eligible suit order';
  function isCurrentProductForm(form) {
    return form instanceof HTMLFormElement && form.action.includes('/cart/add') &&
      form.elements.namedItem('product-id')?.value === root.dataset.productId;
  }
  function markProductForms() {
    if (!claimed || root.dataset.eligible !== 'true') return;
    document.querySelectorAll('form[action*="/cart/add"]').forEach(form => {
      if (!isCurrentProductForm(form)) return;
      let input = form.querySelector('[data-ms-property]');
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = `properties[${propertyName}]`;
        input.dataset.msProperty = '1';
        form.append(input);
      }
      input.value = propertyValue;
    });
  }
  // Re-read the claim at serialization time, including sticky and express buttons.
  document.addEventListener('formdata', event => {
    if (claimed && root.dataset.eligible === 'true' && isCurrentProductForm(event.target)) {
      event.formData.set(`properties[${propertyName}]`, propertyValue);
    }
  }, true);
  let pendingSync;
  let syncAgain = false;
  function syncClaim() {
    if (!claimed) return Promise.resolve(true);
    if (pendingSync) { syncAgain = true; return pendingSync; }
    pendingSync = (async () => {
      try {
        const base = window.Shopify?.routes?.root || '/';
        const response = await fetch(base + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } });
        if (!response.ok) throw Error('Cart unavailable');
        const cart = await response.json();
        const eligible = cart.items.some(item => ids.has(String(item.product_id)));
        const wanted = eligible ? 'One complimentary tailored dress shirt claimed with eligible suit order. Includes any shirt already offered with suit. Confirm colour and measurements during tailoring.' : '';
        if ((cart.attributes?.['Complimentary tailored shirt'] || '') !== wanted) {
          const saved = await fetch(base + 'cart/update.js', {
            method: 'POST', credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ attributes: { 'Complimentary tailored shirt': wanted } })
          });
          if (!saved.ok) throw Error('Claim could not be recorded');
        }
        let banner = document.getElementById('ms-cart-claim');
        if (root.dataset.page === 'cart' && eligible) {
          if (!banner) {
            banner = document.createElement('div');
            banner.id = 'ms-cart-claim';
            banner.className = 'ms-cart-claim';
            document.querySelector('#MainContent')?.prepend(banner);
          }
          banner.innerHTML = '<strong>Your complimentary tailored shirt is recorded with this cart.</strong><p>One shirt will be tailored with your eligible suit order. We’ll confirm colour and measurements during tailoring. No coupon needed.</p>';
          banner.hidden = false;
        } else if (banner) banner.hidden = true;
        return true;
      } catch {
        let banner = document.getElementById('ms-cart-claim');
        if (root.dataset.page === 'cart') {
          if (!banner) {
            banner = document.createElement('div');
            banner.id = 'ms-cart-claim';
            banner.className = 'ms-cart-claim';
            document.querySelector('#MainContent')?.prepend(banner);
          }
          banner.hidden = false;
          banner.setAttribute('role', 'alert');
          banner.textContent = 'Your signup is saved, but the shirt claim could not be added to this cart. Please reload or contact Menista before ordering.';
        }
        return false;
      }
    })().finally(() => {
      pendingSync = null;
      if (syncAgain) { syncAgain = false; syncClaim(); }
    });
    return pendingSync;
  }
  markProductForms();
  if (claimed) syncClaim();
  document.addEventListener('cart:update', syncClaim);
  document.addEventListener('cart:change', syncClaim);
  document.addEventListener('shopify:section:load', markProductForms);
  window.addEventListener('pageshow', markProductForms);
  document.addEventListener('submit', event => {
    if (isCurrentProductForm(event.target) && claimed) {
      markProductForms();
      setTimeout(syncClaim, 1000);
      setTimeout(syncClaim, 3000);
    }
  }, true);
  // Full cart checkout submissions also carry the attribute without an async race.
  document.addEventListener('formdata', event => {
    if (!claimed || !event.target.action.includes('/cart') || event.target.action.includes('/cart/add')) return;
    if (document.getElementById('ms-cart-claim') && !document.getElementById('ms-cart-claim').hidden) {
      event.formData.set('attributes[Complimentary tailored shirt]', 'One complimentary tailored dress shirt claimed with eligible suit order. Confirm colour and measurements during tailoring.');
    }
  }, true);
  if (popup && !claimed && !read(seenKey) && root.dataset.subscribed !== 'true' && !document.documentElement.classList.contains('shopify-design-mode')) {
    const start = Date.now();
    const scroller = document.querySelector('.page-wrapper');
    const y = () => Math.max(window.scrollY, scroller?.scrollTop || 0);
    const initial = y();
    let scrolled = false;
    function maybeShow() {
      if (read(seenKey) || !scrolled || y() < 500 || Date.now() - start < 12000) return;
      if (!(root.dataset.page === 'index' || root.dataset.page === 'product' && inline)) return;
      const target = root.dataset.page === 'product' ? inline : [...document.querySelectorAll('#MainContent h2,#MainContent h3')].find(node => node.textContent.trim().toLowerCase() === 'featured suits');
      const reached = target ? (root.dataset.page === 'product' ? target.getBoundingClientRect().bottom < 0 : target.getBoundingClientRect().top < innerHeight * .85) : y() / Math.max(1, (scroller?.scrollHeight || document.documentElement.scrollHeight) - innerHeight) > .45;
      if (!reached || document.querySelector('dialog[open],cart-drawer[open]') || document.activeElement?.matches('input,textarea,select') || document.visibilityState !== 'visible') return;
      write(seenKey, '1');
      popup.showModal();
    }
    document.addEventListener('scroll', () => { if (Math.abs(y() - initial) > 80) scrolled = true; maybeShow(); }, { passive: true, capture: true });
    setTimeout(maybeShow, 12500);
  }
})();
